import Vue from 'vue';
import productsApi from '../../../api/products';
import formsApi from '../../../api/forms';
import shippingApi from '../../../api/shipping';
import { productErrorMessages } from '@/lib/statics';

const SET_PROVINCES = 'SET_PROVINCES';
const SET_CITIES = 'SET_CITIES';
const SET_SUBDISTRICTS = 'SET_SUBDISTRICTS';
const SET_SUBDISTRICT_FETCHING = 'SET_SUBDISTRICT_FETCHING';
const SET_PRODUCT_INVENTORIES = 'SET_PRODUCT_INVENTORIES';
const SET_PRODUCT_VARIANTS = 'SET_PRODUCT_VARIANTS';
const SET_PRODUCT_VARIANTS_PRICE = 'SET_PRODUCT_VARIANTS_PRICE';
const INPUT_PRODUCT_VARIANT_PRICE = 'INPUT_PRODUCT_VARIANT_PRICE';
const ADD_PRODUCT_VARIANT_ATTRIBUTE = 'ADD_PRODUCT_VARIANT_ATTRIBUTE';
const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';

const state = {
	step: 'product',
	backgroundColors: [
		{ name: 'grey', code: '#eef1f3' },
		// { name: 'black', code: '#222629' },
		{ name: 'green', code: '#EDFDEB' },
		{ name: 'brown', code: '#dad6ce' },
		{ name: 'blue', code: '#edf3f3' },
	],
	buyButtonColors: [
		{ name: 'green', code: '#3cb878' },
		{ name: 'orange', code: '#f7941d' },
		{ name: 'red', code: '#ed1c24' },
		{ name: 'blue', code: '#2eb1ff' },
	],
	provinces: [],
	cities: [],
	subdistricts: [],
	isFetchingProvince: false,
	isFetchingCity: false,
	isFetchingSubdistrict: false,
	isCreatingProduct: false,
	isUpdatingProduct: false,
	submitActionTypes: [
		{ key: 'success_page', label: 'Show Success Page' },
		{ key: 'custom_url', label: 'Redirect to custom URL' },
		{ key: 'wa', label: 'Redirect to WhatsApp (Random)' },
		{ key: 'cs_wa', label: 'Redirect to WhatsApp (CS Number)' },
	],
	productData: null,
	formData: null,
	steps: productErrorMessages,
	isVariableWholesaleError: false,
	productInventories: [],
};

const getters = {
	step: state => state.step,
	buyButtonColors: state => state.buyButtonColors,
	fields: state => state.fields,
	checkoutUrl: state => state.checkoutUrl,
	previewType: state => state.previewType,
	backgroundColors: state => state.backgroundColors,
	provinces: state => state.provinces,
	cities: state => state.cities,
	subdistricts: state => state.subdistricts,
	isFetchingProvince: state => state.isFetchingProvince,
	isFetchingCity: state => state.isFetchingCity,
	isFetchingSubdistrict: state => state.isFetchingSubdistrict,
	isCreatingProduct: state => state.isCreatingProduct,
	isUpdatingProduct: state => state.isUpdatingProduct,
	submitActionTypes: state => state.submitActionTypes,
	productData: state => state.productData,
	formData: state => state.formData,
	stepErrors: state => step => state.steps[step].errors,
	isFieldError: state => (step, key) => state.steps[step].errors[key] !== undefined,
	getFieldErrorMessage: state => (step, key) => state.steps[step].errors[key],
	getErrorMessage: state => (step, key) => state.steps[step].errorMessages[key],
	isVariableWholesaleError: state => state.isVariableWholesaleError,
	productInventories: state => state.productInventories,
};

const mutations = {
	setStep(state, step) {
		state.step = step;
	},
	[SET_PROVINCES](state, provinces) {
		state.provinces = provinces;
	},
	[SET_CITIES](state, cities) {
		state.cities = cities;
	},
	[SET_SUBDISTRICTS](state, subdistricts) {
		state.subdistricts = subdistricts;
	},
	setProvinceFetching(state, value) {
		state.isFetchingProvince = value;
	},
	setCityFetching(state, value) {
		state.isFetchingCity = value;
	},
	[SET_SUBDISTRICT_FETCHING](state, value) {
		state.isFetchingSubdistrict = value;
	},
	[SET_ERROR_MESSAGES](state, payload) {
		state.steps[payload.step].errorMessages[payload.keyMessage] = payload.message;
	},
	setCreatingProductStatus(state, value) {
		state.isCreatingProduct = value;
	},
	setUpdatingProductStatus(state, value) {
		state.isUpdatingProduct = value;
	},
	setProduct(state, value) {
		state.productData = value;
	},
	setForm(state, value) {
		state.formData = value;
	},
	addStepError(state, { step, key, error }) {
		Vue.set(state.steps[step].errors, key, error);
	},
	removeStepError(state, { step, key }) {
		Vue.delete(state.steps[step].errors, key);
	},
	clearStepError(state, step) {
		state.steps[step].errors = {};
	},
	resetErrors(state) {
		state.steps.product.errors = {};
		state.steps.checkoutPage.errors = {};
		state.steps.successPage.errors = {};
	},
	setVariableWholesaleError(state, value) {
		state.isVariableWholesaleError = value;
	},
	[SET_PRODUCT_INVENTORIES](state, inventories) {
		state.productInventories = inventories;
	},
	[SET_PRODUCT_VARIANTS](state, prices) {
		if (state.productData) {
			for (let index = 0; index < state.productData.variations.prices.length; index++) {
				const variationPrice = state.productData.variations.prices[index];
				const sameNameIndex = prices.findIndex(
					price => price.name === variationPrice.name,
				);
				if (sameNameIndex !== -1) {
					const price = prices[sameNameIndex];
					state.productData.variations.prices[index].stock.quantity = price.stock.quantity;
				}
			}
		}
	},
	[SET_PRODUCT_VARIANTS_PRICE](state, prices) {
		state.productData.variations.prices = prices;
	},
	[INPUT_PRODUCT_VARIANT_PRICE](state, payload) {
		state.productData.variations.prices[payload.index].stock.quantity = payload.value;
	},
	[ADD_PRODUCT_VARIANT_ATTRIBUTE](state, payload) {
		state.productData.variations.attributes.push(payload);
	},
};

const actions = {
	changeStep({ commit }, step) {
		commit('setStep', step);
		window.scrollTo(0, 0);
	},
	fetchProvinces({ commit }) {
		commit('setProvinceFetching', true);
		const callback = (response) => {
			commit('setProvinceFetching', false);
			const provinces = response.data;
			commit(SET_PROVINCES, provinces);
		};
		const errorCallback = (e) => {
			commit('setProvinceFetching', false);
			// eslint-disable-next-line
			console.log(e);
		};
		shippingApi.getAllProvinces(callback, errorCallback);
	},
	fetchCities({ commit }, provinceId) {
		commit('setCityFetching', true);
		const params = {
			province_id: provinceId,
		};
		const callback = (response) => {
			commit('setCityFetching', false);
			const cities = response.data;
			commit(SET_CITIES, cities);
		};
		const errorCallback = () => {
			commit('setCityFetching', false);
		};
		shippingApi.getCities(params, callback, errorCallback);
	},
	fetchSubdistricts({ commit }, cityId) {
		commit(SET_SUBDISTRICT_FETCHING, true);
		const callback = (response) => {
			commit(SET_SUBDISTRICT_FETCHING, false);
			const subdistricts = response.data;
			commit(SET_SUBDISTRICTS, subdistricts);
		};
		const errorCallback = () => {
			commit(SET_SUBDISTRICT_FETCHING, false);
		};
		shippingApi.getSubdistricts(cityId, callback, errorCallback);
	},
	clearCities({ commit }) {
		commit(SET_CITIES, []);
	},
	clearSubdistricts({ commit }) {
		commit(SET_SUBDISTRICTS, []);
	},
	setProductData({ commit }, productData) {
		commit('setProduct', productData);
	},
	createProduct({ commit }, { params, cb, errorCb }) {
		commit('setCreatingProductStatus', true);
		const callback = (response) => {
			commit('setCreatingProductStatus', false);
			const product = response.data;
			commit('setProduct', product);
			if (product.status !== 'draft' && !params.supplier_user_id) { // redirect back if is admin
				commit('setStep', 'done');
			}
			if (cb) {
				cb(response);
			}
		};
		const errorCallback = (e) => {
			commit('setCreatingProductStatus', false);
			// eslint-disable-next-line
			console.log(e);
			if (errorCb) {
				errorCb(e);
			}
		};
		productsApi.createProduct(params, callback, errorCallback);
	},
	updateProduct({ commit }, { id, params, cb, errorCb }) {
		commit('setUpdatingProductStatus', true);
		const callback = (response) => {
			commit('setUpdatingProductStatus', false);
			cb(response);
		};
		const errorCallback = (e) => {
			commit('setUpdatingProductStatus', false);
			// eslint-disable-next-line
			console.log(e);
			errorCb(e);
		};
		productsApi.update(id, params, callback, errorCallback);
	},
	setFormData({ commit }, formData) {
		commit('setForm', formData);
	},
	createForm({ commit }, params) {
		commit('setCreatingProductStatus', true);
		const callback = () => {
			commit('setCreatingProductStatus', false);
			commit('setStep', 'done');
		};
		const errorCallback = (e) => {
			commit('setCreatingProductStatus', false);
			// eslint-disable-next-line
			console.log(e);
		};
		formsApi.create(params, callback, errorCallback);
	},
	updateForm({ commit }, { id, params }) {
		commit('setCreatingProductStatus', true);
		const callback = () => {
			commit('setCreatingProductStatus', false);
			commit('setStep', 'done');
		};
		const errorCallback = (e) => {
			commit('setCreatingProductStatus', false);
			// eslint-disable-next-line
			console.log(e);
		};
		formsApi.update(id, params, callback, errorCallback);
	},
	addStepError({ commit }, params) {
		commit('addStepError', params);
	},
	removeStepError({ commit }, params) {
		commit('removeStepError', params);
	},
	clearStepError({ commit }, step) {
		commit('clearStepError', step);
	},
	resetStepErrors({ commit }) {
		commit('resetErrors');
	},
	changeVariableWholesaleError({ commit }, value) {
		commit('setVariableWholesaleError', value);
	},
	setProductInventories({ commit }, inventories) {
		commit(SET_PRODUCT_INVENTORIES, inventories);
	},
	setProductVariant({ commit }, prices) {
		commit(SET_PRODUCT_VARIANTS, prices);
	},
	setProductVariantPrice({ commit }, prices) {
		commit(SET_PRODUCT_VARIANTS_PRICE, prices);
	},
	inputProductVariantPrice({ commit }, payload) {
		commit(INPUT_PRODUCT_VARIANT_PRICE, payload);
	},
	addProductVariantAttribute({ commit }, payload) {
		commit(ADD_PRODUCT_VARIANT_ATTRIBUTE, payload);
	},
	setErrorMessage({ commit }, payload) {
		commit(SET_ERROR_MESSAGES, payload);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
